import axios from 'axios';
import {api} from '#constants/appUrl';

const url = api + 'files/download'
const headers = {
    'Content-Type': 'multipart/form-data',
    'accept': 'application/json',
    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
}

const filesRepository = {
    state: {
        progress: 0,
        question_id: null
    },
    mutations: {
        setProgress(state, data) {
            state.progress = data
        },
        setQuestionId(state, data) {
            state.question_id = data
        }
    },
    actions: {
        uploadFile({ commit }, data) {
            commit('setQuestionId', data.question_id)
        },
        downloadFile({commit}, data) {
            return new Promise((resolve, reject) => {
                axios.get(data.url, {
                    headers: headers,
                    responseType: 'blob'
                }).then((response) => {
                    resolve(response)
                }).catch((error) => {
                    reject(error)
                })
            })
        },
        resetProgress({commit}) {
            commit('setProgress', 0);
        },
        setProgress({commit}, data) {
            commit('setProgress', data);
        },
        deleteFile({commit}, data) {
            return new Promise((resolve, reject) => {
                axios.post(`${api}delete-file/${data.procedure}`, data, {
                    headers: headers
                }).then((response) => {
                    resolve(response)
                }).catch((error) => {
                    reject(error)
                })
            })
        }
    }
}

export default filesRepository
